import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/components/sections/auth/Login'
import DriverTools from '@/components/sections/driver-tools/Driver'
import ResetPasswordReq from '@/components/sections/auth/ResetPasswordReq'
import UpdatePassword from '@/components/sections/auth/UpdatePassword'
import ReservationsIndex from '@/components/sections/reservations/Index'
import OperationIndex from '@/components/sections/reservations/Operation'
import OperationTrackingIndex from '@/components/sections/reservations/OperationTracking'
import UsersIndex from '@/components/sections/users/Index'
import TransportUnitsIndex from '@/components/sections/transport-units/Index'
import ProfileIndex from '@/components/sections/profile/Index'
import AccessDenied from '@/components/helpers/AccessDenied'
import ImportBookings from '@/components/sections/reservations/ImportBookings'
import Dashboard from '@/components/sections/dashboard/Index'
import ReportRides from '@/components/sections/reports/rides/Single'
import ReportReviews from '@/components/sections/reports/reviews/Single'
import SalesChannelModule from '@/components/sections/sale-channels/Index'
import zonedAreas from '@/components/sections/zoned-areas/Index'
import SingleZonedArea from '@/components/sections/zoned-areas/Single'//manage zones
import ServiceTypesModule from '@/components/sections/service-types/Index'
import SalesChannelShow from '@/components/sections/sale-channels/Show'
// import store from '../store'

Vue.use(VueRouter)
const routes = [
	{path: '/', component: Dashboard},
	{path: '/operation', component: OperationIndex},
	{path: '/operation-tracking', component: OperationTrackingIndex},
	{name:'Login', path: '/login', component: Login},
	{name:'DriverTools', path: '/driver', component: DriverTools},
	{name:'ResetPasswd', path: '/reset-passwd', component: ResetPasswordReq},
	{name:'UpdatePasswd', path: '/update-passwd', component: UpdatePassword},
	{path: '/reservations', component: ReservationsIndex},
	{path: '/ride/:serviceNumber', component: ReservationsIndex},
	{path: '/users', component: UsersIndex},
	{path: '/transport-units', component: TransportUnitsIndex},
	{path: '/profile', component: ProfileIndex},
	{path: '/denied', component: AccessDenied},
	{path: '/imports', component: ImportBookings, meta: {driverRoute: true}},
	{path: '/reports/rides', component: ReportRides},
	{path: '/reports/reviews', component: ReportReviews},
	{path: '/sales-channels', component: SalesChannelModule, meta: { onlyTransportist: true }},
	{path: '/operation-areas/', component: zonedAreas, meta: { onlyTransportist: true }},
	{path: '/operation-area/:zonedAreaId', component: SingleZonedArea,props:true,meta: { onlyTransportist: true }},
	{path: '/service-types', component: ServiceTypesModule,props:true,meta: { onlyTransportist: true }},
	{path: '/sales-channel/:salesChannelId', component: SalesChannelShow,props:true, meta: { onlyTransportist: true }}

  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
})
router.beforeEach((to, from, next) => {
	let currentUser = localStorage.getItem("user");
	currentUser = currentUser ? JSON.parse(currentUser) : null;

	if (['Login','ResetPasswd','UpdatePasswd','DriverTools'].indexOf(to.name) === -1 && currentUser === null){
		next({ name: 'Login' })
	}else if(currentUser !== null){
		next()
	}
	else next()
})

router.beforeEach((to, from, next) => {
	let isTransportist        = false;
	let currentSystemSettings = localStorage.getItem("system");
	try{
		let currentSystemSettings = localStorage.getItem("system");
		currentSystemSettings     = currentSystemSettings ? JSON.parse(currentSystemSettings) : null;
		isTransportist            = currentSystemSettings.system.isTransportist
	}catch(err){
		console.log(err)
	}
	if (to.matched.some(record => record.meta.onlyTransportist)) {
		if (currentSystemSettings &&  isTransportist) {
			next();
		}else{
			next({
				path: '/'
			});
		}
	}
	next();

})



export default router
